// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__q_GiJ","icon":"style_icon__j3yXx","flag":"style_flag__3NiT3","menuIcon":"style_menuIcon__eo5NZ"};